/* ROUGHCUT — site navigation. Verbatim from the approved build.
   Guarded so it is inert on any page where the nav isn't rendered,
   and re-armed when Shopify reloads a section in the theme editor. */
(function(){
  function boot(){
    var n=document.getElementById('nav');
    if(!n || n.dataset.armed) return;
    n.dataset.armed='1';
    (()=>{
      const nav=document.getElementById('nav'), panel=document.getElementById('panel'),
            scrim=document.getElementById('scrim'), find=document.getElementById('find'),
            mBtn=document.getElementById('menuBtn'), fBtn=document.getElementById('findBtn'),
            fIn=document.getElementById('findIn'), items=[...panel.querySelectorAll('.item')];
      let menu=false, search=false, last=scrollY, ticking=false;
    
      /* ── the bar ──────────────────────────────────────────────
         Two independent states. `solid` is about WHERE you are.
         `away` is about WHICH WAY you're going. The 6px deadband
         stops it flickering on a trackpad and on the iPhone
         rubber-band bounce at the top of the page. */
      const onScroll=()=>{
        const y=Math.max(0,scrollY), d=y-last;
        nav.classList.toggle('solid', y>40);
        if(Math.abs(d)>6){
          if(!menu && !search){
            const away = d>0 && y>140;
            nav.classList.toggle('away', away);
            /* Mirror it onto <html> so anything sticking BELOW the nav can
               follow it up and down. The step bar on the help page reads
               --rc-nav-offset off this; without it that bar stays pinned
               where the nav used to be and hangs in mid-air. */
            document.documentElement.classList.toggle('rc-nav-away', away);
          }
          last=y;
        }
        ticking=false;
      };
      addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(onScroll)}},{passive:true});
      onScroll();
    
      /* ── open/close. Only one of the two can be open at a time. ── */
      const sync=()=>{
        panel.classList.toggle('open',menu);
        find.classList.toggle('open',search);
        scrim.classList.toggle('open',menu||search);
        nav.classList.toggle('open',menu);
        nav.classList.remove('away');
        document.documentElement.classList.remove('rc-nav-away');
        document.body.classList.toggle('lock',menu||search);
        mBtn.setAttribute('aria-expanded',menu);
        fBtn.setAttribute('aria-expanded',search);
      };
      const setMenu=v=>{menu=v; if(v)search=false; sync();};
      const setSearch=v=>{search=v; if(v)menu=false; sync();
        if(v) setTimeout(()=>fIn.focus({preventScroll:true}),260);};
    
      mBtn.addEventListener('click',()=>setMenu(!menu));
      fBtn.addEventListener('click',()=>setSearch(!search));
      scrim.addEventListener('click',()=>{menu=search=false;sync()});
      items.forEach(i=>i.addEventListener('click',()=>setMenu(false)));
      addEventListener('keydown',e=>{if(e.key==='Escape'&&(menu||search)){menu=search=false;sync()}});
    
      /* No hover on a phone, so the gold marker and the arrow would
         never appear. Fire them on touch instead. */
      if(matchMedia('(hover:none)').matches){
        items.forEach(i=>{
          i.addEventListener('touchstart',()=>i.classList.add('tap'),{passive:true});
          i.addEventListener('touchend',()=>setTimeout(()=>i.classList.remove('tap'),240),{passive:true});
        });
      }
    })();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
